export const COMPONENT_DATA_TEST_ID = "feature-flag-toggler";
export const FLAGSMITH_API_BASE_URL = "https://api.flagsmith.com/api/v1";
export const FLAGSMITH_API_KEY = process.env.REACT_APP_FLAGSMITH_API_KEY;
export const FLAGSMITH_ENVIRONMENT_KEY = process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_ID;
export const FEATURE_STATES_API_URL = `${FLAGSMITH_API_BASE_URL}/environments/${FLAGSMITH_ENVIRONMENT_KEY}/featurestates`;
export const IDENTITY_FEATURE_STATES_API_URL = `${FLAGSMITH_API_BASE_URL}/environments/environments/${FLAGSMITH_ENVIRONMENT_KEY}/edge-identities-featurestates`;
